module.exports = __webpack_public_path__ + "img/payment_pc_02.3cf153b2.png";